document.documentElement.classList.remove('no-js');
(() => {
  const toggle = document.querySelector('.menu-toggle');
  const menu = document.getElementById('MobileMenu');
  if (toggle && menu) {
    toggle.addEventListener('click', () => {
      const open = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!open));
      menu.hidden = open;
      toggle.querySelector('.visually-hidden').textContent = open ? 'Open menu' : 'Close menu';
    });
    menu.querySelectorAll('a').forEach((link) => link.addEventListener('click', () => {
      toggle.setAttribute('aria-expanded', 'false');
      toggle.querySelector('.visually-hidden').textContent = 'Open menu';
      menu.hidden = true;
    }));
  }
  document.querySelectorAll('.product-thumb').forEach((button) => {
    button.addEventListener('click', () => {
      const main = button.closest('.product-page-gallery')?.querySelector('.product-main-media img');
      if (main && button.dataset.fullSrc) main.src = button.dataset.fullSrc;
    });
  });
})();
